import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useOrgUpdate from '@opsbase/react-gql-hooks/organisation/useOrgUpdate';
import markdown from '@opsbase/react-markdown';
import AppPage from '@opsbase/web-app/AppPage';
import EditableList from '@opsbase/web-editablelist';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function AdvancedAssetTypesPage() {
    var _a, _b;
    const self = useSelf();
    const { updateSettings } = useSelfActions();
    const { goTo } = useNav();
    const { data: org } = useOrgFindById({ variables: { id: self.organisationId } });
    const updateOrg = useOrgUpdate();
    const handleChange = useCallback(assetTypes => {
        const patch = {
            assetTypes,
        };
        updateOrg({
            id: org.id,
            patch: {
                settings: {
                    ...patch,
                },
            },
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateOrg: {
                    __typename: 'Organisation',
                    ...org,
                    ...{ settings: { ...org.settings, ...patch } },
                },
            },
        })
            .then(updatedOrg => {
            updateSettings(updatedOrg.settings);
        })
            .catch(doNothing);
    }, [org, updateSettings, updateOrg]);
    const handleDelete = useCallback(assetType => {
        goTo(Pages.ASSET_TYPE_DELETE, { type: assetType.key });
    }, [goTo]);
    return (React.createElement(AppPage, null,
        React.createElement(Vertical, { padding: true, style: { overflow: 'auto' } },
            React.createElement(Pane, { padding: true },
                React.createElement(Text, { variant: "h2" }, markdown(i18n.t('asset-types-question'))),
                !!((_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.assetTypes) && (React.createElement("div", { style: { width: 500 } },
                    React.createElement(EditableList, { autoSelectIdx: 0, placeholder: i18n.t('enter-name-of-new-asset-type'), items: (_b = org === null || org === void 0 ? void 0 : org.settings) === null || _b === void 0 ? void 0 : _b.assetTypes, idField: "key", valueField: "title", canAddInline: true, canAddAtBottom: true, canDelete: true, canReorder: true, onDelete: handleDelete, onChange: handleChange })))))));
}
export default AdvancedAssetTypesPage;
